import { compose } from 'recompose';
import NavGroup from './navGroup';

const enhance = compose();
export default enhance(NavGroup);
